import React, { use, useState } from 'react';
import '../styles/App.css';
import utils from '../utils/utils';

export default function LoginPage({ onLogin }) {

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
 
    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');

        if (!username.trim() || !password.trim()) {
            setError('אנא הזן שם משתמש וסיסמה');
            return;
        }

        try {
            setLoading(true);
            setError("");
            const resp = await utils.requestData('BOSignIn', { username, password });
            if (resp[0][0].code == 0) {
                    onLogin(username);
                    localStorage.setItem("auth-token", resp[1][0].token);

                    setUsername('');
                    setPassword('');
            }else {
                setError(resp[0][0].msg || 'שגיאה בהתחברות');
            }
        } catch (error) {
            console.error("Login error:", error);
            setError('שגיאה בהתחברות, נסה שוב');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-wrapper">

                <div className="login-header">
                    <div className="login-icon-container">
                        <div className="login-icon-box">⚙️</div>
                    </div>
                    <h1 className="login-title">קלאמקע</h1>
                    <p className="login-subtitle">מערכת ניהול</p>
                </div>

                <div className="login-card">
                    <form onSubmit={handleLogin} className="login-form">
                        <div className="form-group">
                            <label className="form-label">שם משתמש</label>
                            <input
                                type="text"
                                placeholder="הזן שם משתמש"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                className="form-input"
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-label">סיסמה</label>
                            <input
                                type="password"
                                placeholder="הזן סיסמה"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="form-input"
                            />
                        </div>

                        {error && <div className="error-message">{error}</div>}

                        <button type="submit" className="login-btn">
                            התחברות
                        </button>
                    </form>


                </div>

                <p className="login-footer">© 2024 Back Office System</p>
            </div>
        </div>
    );
}